import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { User, Calendar, Flag, Phone, MailPlus } from "lucide-react";
import { format } from "date-fns";
import ReactCountryFlag from "react-country-flag";
// import NewEditIcon from "../component/icons/action-edit-icon";
import NewEyeIcon from "../icons/action-eye-icon";
import NewCardIcon from "../icons/action-card-icon";
import { Link } from "react-router";
import Tooltip from "../ui/tooltip";
import DotsVerticalIcon from "../icons/dots-vertical";
import EmployeeDirectoryAddUpdate from "../../pages/organization/emplyee-directory/add-update";
import NewEditIcon from "../icons/action-edit-icon";
import moment from "moment";

export default function LeadCard({
  lead,
  onClick,
  colors,
  country,
  onSuccess = () => {},
  onError = () => {},
  onToggle = () => {},
  isOpen = {},
}) {
  console.log("mylead", lead);

  const [countryCode, setCountryCode] = useState("");
  const [editAccount, setEditAccount] = useState(false);
  const [Menu, showMenu] = useState(false);

  const editDeal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setEditAccount(true);
  };

  useEffect(() => {
    const getCountryCode =
      country?.find((cn) => cn?.country_name == lead?.country) ||
      country.find((cn) => cn?.country_code == lead?.country);
    if (getCountryCode) {
      setCountryCode(getCountryCode.country_code);
    } else {
      setCountryCode("");
    }
  }, []);

  return (
    <>
      <motion.div
        whileTap={{ scale: 0.99 }}
        className="p-[14px] bg-[rgb(255,255,255)]"
        style={{
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderLeft: `3px solid ${colors?.color || "#9D5FEF"}`,
          borderRadius: "12px",
          boxShadow:
            "0px 1px 3px rgba(0, 0, 0, 0.06), 0px 1px 2px rgba(0, 0, 0, 0.04)",
          cursor: "pointer",
          transition: "0.15s",
          transform: "translateY(0px)",
          borderImage: "initial",
        }}
        onClick={() => onClick?.(lead)}
      >
        <div
          className={`font-[600] text-[rgb(26,21,32)] text-[13px] truncate capitalize`}
          style={
            colors?.color
              ? { borderColor: colors?.color }
              : { borderColor: "#9D5FEF" }
          }
        >
          {lead?.name}
        </div>
        {/* Contact Info */}
        <div className="flex flex-col item-start gap-1 text-[11px] text-[rgb(144,136,146)] mb-[4px] mt-1">
          {lead?.contact_phone && (
            <div className="flex items-center gap-1">
              <Phone className="w-3 h-3" />
              <span>{lead.contact_phone}</span>
            </div>
          )}
          {lead?.contact_email && (
            <div className="flex items-center gap-1">
              <MailPlus className="w-3 h-3" />
              <span className="truncate">{lead.contact_email}</span>
            </div>
          )}
        </div>

        <div className="text-[11px] text-[rgb(144,136,146)] mb-[8px] capitalize">
          {lead?.source ?? "--"}
        </div>
        <div className="flex justify-between items-center">
          <span className="text-[13px] font-[700] text-[rgb(79,70,229)]">
            {lead?.amount}
          </span>
          <span className="text-[10px] text-[rgb(144,136,146)]">
            {lead?.time || "-"}
            {/* {moment(lead.time, "DD-MMM-YYYY").fromNow()} */}
          </span>
        </div>

        <div className="flex gap-[4px] mt-[8px] flex-wrap">
          <span className="text-[10px] py-[2px] px-[7px] bg-[rgb(243,239,233)] text-[rgb(92,84,102)] border border-solid border-[rgba(0,0,0,0.08)] rounded-[4px] capitalize">
            {lead?.product_name ?? "N/A"}
          </span>
        </div>
      </motion.div>

      {editAccount && (
        <EmployeeDirectoryAddUpdate
          onClose={() => {
            setEditAccount(false);
          }}
          data={lead?.completeLead}
          tabIndex={0}
          onError={onError}
          onSubmit={onSuccess}
        />
      )}
    </>
  );
}
